import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { X } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const ChartModal = ({
  isOpen,
  onClose,
  title,
  children,
  headerActions,
  // Equipment filter props
  equipmentList = [],
  selectedEquipment = 'all',
  onEquipmentChange,
  showEquipmentFilter = false,
  filterLabel = 'All Equipment', // Custom label for the filter dropdown (e.g., "All Drivers")
  // Sort filter props
  showSortFilter = false,
  sortOrder = 'low-high',
  onSortChange
}) => {
  return (
    <Dialog title={title} open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-full max-w-[95vw] lg:max-w-[90vw] xl:max-w-[85vw] 2xl:max-w-[1440px] h-[90vh] lg:h-[85vh] max-h-[800px] 2xl:max-h-[900px] p-0 flex flex-col translate-x-[-50%] translate-y-[-50%] left-[50%] top-[50%] overflow-hidden sm:rounded-lg">
        {/* Header */}
        <div className="bg-white border-b border-gray-100 px-4 py-3 lg:px-6 lg:py-4 flex flex-col gap-3 flex-shrink-0">
          {/* Top Row: Title and Close Button */}
          <div className="flex items-center justify-between gap-4">
            <DialogTitle className="text-base lg:text-lg 2xl:text-xl font-bold font-open-sans text-gray-900 m-0 line-clamp-1">
              {title}
            </DialogTitle>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors flex-shrink-0"
              aria-label="Close"
            >
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>

          {/* Navigation/Filters Row */}
          {(showEquipmentFilter || showSortFilter || headerActions) && (
            <div className="flex items-center gap-2 lg:gap-3 flex-wrap">
              {showEquipmentFilter && (
                <Select value={selectedEquipment} onValueChange={onEquipmentChange}>
                  <SelectTrigger className="w-[140px] lg:w-[180px] 2xl:w-[220px] h-9 2xl:h-10 text-xs 2xl:text-sm bg-gray-50 border-gray-200">
                    <SelectValue placeholder={filterLabel} />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">{filterLabel}</SelectItem>
                    {equipmentList.map((equipment) => (
                      <SelectItem key={equipment} value={equipment}>
                        {equipment}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}

              {showSortFilter && (
                <Select value={sortOrder} onValueChange={onSortChange}>
                  <SelectTrigger className="w-[130px] lg:w-[150px] 2xl:w-[180px] h-9 2xl:h-10 text-xs 2xl:text-sm bg-gray-50 border-gray-200">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="low-high">Low to High</SelectItem>
                    <SelectItem value="high-low">High to Low</SelectItem>
                  </SelectContent>
                </Select>
              )}
              {headerActions}
            </div>
          )}
        </div>

        {/* Chart Content */}
        <div className="flex-1 bg-white relative flex flex-col overflow-hidden min-h-0">
          <div className="flex-1 w-full overflow-auto p-4 lg:p-6 lg:pl-0 lg:pt-6 lg:pr-6 min-h-0">
            {children}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ChartModal;

